




















































import { defineComponent, reactive, toRefs } from '@vue/composition-api';
import { useStore } from '@/utils/use-store';

export default defineComponent({
  props: {
    page: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const store = useStore();
    const { user } = store.state;

    let navbarItems = [
      {
        title: 'Dashboard',
        icon: 'mdi-home-variant',
        link: '/',
        name: 'home'
      },
      {
        title: 'Content Groups',
        icon: 'mdi-ticket',
        link: '/activity-group',
        name: 'activity'
      },
      {
        title: 'Content Management',
        icon: 'mdi-video',
        link: '/content-management',
        name: 'content-management'
      },
      {
        title: 'Warm Up',
        icon: 'mdi-file-tree',
        link: '/warm-up',
        name: 'warmup'
      },
      {
        title: 'Questions',
        icon: 'mdi-cloud-question',
        link: '/question',
        name: 'question'
      },
      {
        title: 'Exercise',
        icon: 'mdi-file-tree',
        link: '/exercise',
        name: 'exercise'
      },
      // {
      //   title: 'Intro Sessions',
      //   icon: 'mdi-numeric',
      //   link: '/intros',
      //   name: 'Intros'
      // },
      {
        title: 'Session',
        icon: 'mdi-calendar',
        link: '/session',
        name: 'session'
      },
      {
        title: 'Homework',
        icon: 'mdi-folder-download',
        link: '/homework',
        name: 'homework'
      },
      {
        title: 'Category',
        icon: 'mdi-shape-outline',
        link: '/category',
        name: 'category'
      }
    ];

    if (user.role === 'admin') {
      navbarItems = [
        ...navbarItems,
        // {
        //   title: 'Coupons',
        //   icon: 'mdi-ticket-percent',
        //   link: 'coupon',
        //   name: 'coupon'
        // },
        // {
        //   title: 'Provider',
        //   icon: 'mdi-doctor',
        //   link: '/provider',
        //   name: 'provider'
        // },
        {
          title: 'Users',
          icon: 'mdi-account-group',
          link: '/users',
          name: 'users'
        },
        {
          title: 'Badges',
          icon: 'mdi-trophy-award',
          link: '/badge',
          name: 'badges'
        },
        {
          title: 'Ad Admin',
          icon: 'mdi-view-dashboard-variant',
          link: '/ad-admin',
          name: 'ad-admin-campaigns'
        },
        {
          title: 'Ad Campaign Stats',
          icon: 'mdi-chart-donut',
          link: '/ad',
          name: 'ad-list'
        }
      ];
    }

    if (user.role === 'provider') {
      navbarItems = [
        ...navbarItems,
        {
          title: 'Schedule',
          icon: 'mdi-clock-outline',
          link: '/schedule',
          name: 'schedule'
        }
      ];
    }

    const navbarState = reactive({
      open: true
    });

    return {
      ...toRefs(navbarState),
      navbarItems
    };
  }
});

